import ReactMarkdown from 'react-markdown';
import {useTranslation} from 'react-i18next';
import {styled} from '@mui/material';

const PrivacyPolicy = ({content}: {content: string}) => {
  const {t} = useTranslation('common');
  const markdown = t(content);

  return <StyledReactMarkdown children={markdown} />;
};
export default PrivacyPolicy;

const StyledReactMarkdown = styled(ReactMarkdown)(({theme}) => ({
  color: theme.palette.common.black,
  backgroundColor: theme.palette.common.white,
  padding: '4rem',
  paddingTop: '1rem',
}));
